import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

// Relit en arrière-plan les contrats de tous les véhicules liés et complète leurs infos vides.
export const RefreshAllVehiclesButton = ({ onDone }) => {
  const [status, setStatus] = useState(null);
  const timer = useRef(null);
  const wasRunning = useRef(false);

  const poll = async () => {
    try {
      const { data } = await api.get("/fleet/refresh-from-contracts");
      setStatus(data);
      const running = data.job?.status === "running";
      if (running) { wasRunning.current = true; timer.current = setTimeout(poll, 5000); }
      else if (wasRunning.current) {
        wasRunning.current = false;
        const j = data.job;
        toast.success(`${j.vehicles_updated} véhicule(s) complété(s) · ${j.fields_filled} info(s) ajoutée(s)`
          + (j.errors ? ` · ${j.errors} erreur(s)` : ""));
        onDone?.();
      }
    } catch { /* silencieux */ }
  };
  useEffect(() => { poll(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    if (!window.confirm(`Relire par IA les contrats de ${status?.eligible || 0} véhicule(s) ? Compte ≈ 15 s par véhicule (appel Gemini facturé sur ta clé). Les infos existantes ne sont jamais écrasées.`)) return;
    try {
      await api.post("/fleet/refresh-from-contracts");
      toast.success("Relecture lancée en arrière-plan — tu peux continuer à travailler");
      poll();
    } catch (e) { toast.error(apiError(e)); }
  };

  const running = status?.job?.status === "running";
  if (!status || (!running && !status.eligible)) return null;
  return (
    <Button variant="outline" onClick={start} disabled={running} data-testid="fleet-refresh-all-btn">
      {running ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1.5" />}
      {running ? `Relecture ${status.job.done}/${status.job.total}…` : `Compléter ${status.eligible} véhicule(s) depuis leurs contrats`}
    </Button>
  );
};
